/* eslint-disable */
import type { Image } from "../../ui/Image.pb";

export interface ImageAsset {
  image?: Image;
  /** Type can currently only be "lifestyle". */
  image_type?: string;
  /** Color to be used for foreground text rendered over the image. */
  text_color?: ImageAssetTextColor;
  /** Whether a dark background blur should be applied over the image to add additional contrast. */
  dimmer_mode?: ImageAssetDimmerMode;
}

export enum ImageAssetTextColor {
  UNKNOWN_TEXT_COLOR = "UNKNOWN_TEXT_COLOR",
  BLACK = "BLACK",
  WHITE = "WHITE",
}

export enum ImageAssetDimmerMode {
  UNKNOWN_DIMMER_MODE = "UNKNOWN_DIMMER_MODE",
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
